<!--实时需量-->
<template>
	<div class="demandRTCurveBody">
		<elCheckBoxTree slot="tree" :dataList='getDemanList' @checkItem="treeCheckItem"></elCheckBoxTree>
		<div class="pageBody" slot="body">
			<!--表格显示数据-->
			<div class="monreportRigth">
				<div class="infolist" style="height: calc(65% - .37rem);">
					<vchart style="width: 100%;height: 100%;" ref='vchart'></vchart>
				</div>
				<infoList ref="infoList" style="height: 35%;" :columns='columns' :dataList="nowPage" :pageLen='pageLen'
				 :totalSize="dataList.length" @selectPage="nowIndex = $event" :fillAll="true"></infoList>
			</div>
		</div>
	</div>
</template>
<script>
	import treeBody from '@/components/module/slotModule/treeBody.vue'
	import iconButton from '@/components/module/universal/iconButton.vue'
	import vchart from '@/components/module/chart/vchart.vue'
	import infoList from '@/components/module/universal/infoList.vue'
	import elCheckBoxTree from '@/components/module/tree/elCheckBoxTree.vue'
	export default {
		components: {
			treeBody,
			iconButton,
			vchart,
			infoList,
			elCheckBoxTree,
		},
		props: {},
		data() {
			return {
				nowIndex: 0,
				nowDeviceList: [],
				variableTreeResult: {},
				nowSeries: [],
				refreshInterval: 2000,
				columns: [{
					name: '设备名称',
					key: 'devicename'
				},{
					name: '变量名称',
					key: 'variableName'
				}, {
					name: '实时值',
					key: 'value'
				}],
				from2name: {},
				demandTree: [],
				demandApptypeList: [264, 265, 266, 267, 268, 269]
			}
		},
		created() {
			debugPage=this
		},
		mounted() {
			debugPage = this
			this.options = this.$refs.vchart.getDefaultOptions()
			this.options.title.text = "需量实时曲线"
			this.options.tooltip.formatter = (params, ticket, callback) => {
				var label = new Date(params[0].data[0]).formatByTime() + "</br>"
				params.forEach(item => {
					var values;
					if (isnull(item.data[1])) {
						values = "无采集数据";
					} else {
						values = cutDigital(item.data[1]);
					}
					label += item.seriesName + " : " + values + "</br>"
				})
				return label;
			}
			this.options.toolbox.show = false
			this.options.dataZoom = [{
					type: 'slider',
					show: true,
					start: 0,
					end: 100,
					handleSize: 8
				},
				{
					type: 'inside',
					start: 0,
					end: 100
				}
			]
			this.options.xAxis = {
				type: 'time',
				splitLine: {
					show: true
				}
			}

			this.$refs.vchart.setData(this.options, true)
			addNewTask('refreshDemandRTCurve', 2000, this.refreshInterval, -1, () => {
				this.addData()
			})
			this.loadDemandTree()
		},
		destroyed() {
			removeTask('refreshDemandRTCurve')
			this.realTimeValueStore.commit("removeKeys", this.nowVariableNameList)
		},
		computed: {
			getDemanList(){
				let tree=this.$store.deviceStore.getters.getDeman(this.nowUnit.id)
				let list=[]
				if(!isempty(tree)){
					list=[deviceList(tree)]
				}
				return list;
			},
			getBackgroudImageStyle() {
				return this.$store.resourcesStore.getters.getBackgroudImageStyle
			},
			getResourcesByName() {
				return this.$store.resourcesStore.getters.getResourcesByName
			},
			getColorById() {
				return this.$store.resourcesStore.getters.getColorById
			},
			realTimeValueStore() {
				return this.$store.realTimeValueStore
			},
			nowUnit() {
				return this.$store.unitStore.getters.getNowUnit
			},
			nowVariableTree() {
				if (isempty(this.nowDeviceList)) {
					return []
				}
				var variableTreeArr = []
				this.nowDeviceList.forEach(item => {
					var variableTree = this.$store.variableStore.getters.getVariableTree(item.no)
					variableTree.forEach(tree => {
						tree.devicename = item.name
					})
					variableTreeArr.push(variableTree)
				})
				var result = []
				variableTreeArr.forEach(item => {
					result = result.concat(item)
				})
				return result
			},
			nowVariableList() {
				if (isempty(this.nowDeviceList)) {
					return []
				}
				// 当前要显示的变量列表
				var variableList = []
				for (var i = 0, len = this.nowVariableTree.length; i < len; i++) {
					var item = this.nowVariableTree[i]
					for (var i1 = 0, len1 = item.next.length; i1 < len1; i1++) {
						var item1 = item.next[i1]
						item1.devicename = item.devicename
						if (this.demandApptypeList.includes(item1.typeNo)) {
							var newItem = copy(item1)
							newItem.name = newItem.name.subByFirstChar(".")
							variableList.push(newItem)
						}
					}
				}
				variableList.sort((a, b) => {
					return a.typeNo - b.typeNo
				})
				return variableList
			},
			nowVariableNameList() {
				this.from2name = {}
				return this.nowVariableList.map(item => {
					this.$set(this.from2name,item.fromName,item.name)
					return item.fromName
				})
			},
			pageLen() {
				return this.dataList.length < 20 ? this.dataList.length : 20
			},
			nowPage() {
				// 按照页码来返回当前应该显示的列表
				var list = this.dataList.filter((item, index) => {
					return index >= this.nowIndex * this.pageLen && index < (this.nowIndex + 1) * this.pageLen
				})
				return list
			},
			dataList() {
				if (isempty(this.nowVariableNameList)) {
					return []
				}
				//获取实时值
				var vl = this.realTimeValueStore.getters.getValue(this.nowVariableNameList)
				var nameList = []
				return this.nowVariableNameList.map((item, index) => {
					var value = vl[index]
					if (isNaN(parseFloat((value))) || isnull(parseFloat((value)))) {
						value = "--"
					}
					var name = this.from2name[item] ? this.from2name[item] : item
					
					var indexLabel = 0
					nameList.forEach(i => {
						if (i == name) {
							indexLabel++
						}
					})
					nameList.push(name)
					if (indexLabel > 0) {
						name = name + indexLabel
					}
					return {
						devicename: this.nowVariableList[index].fromName.split('.')[0],
						variableName: name,
						value
					}
				})
			},
		},
		watch: {
			nowVariableNameList(nv, ov) {
				this.realTimeValueStore.commit("removeKeys", ov)
				this.realTimeValueStore.commit("addKeys", nv)
				//重置缓存数据
				var list = []
				var dataList = []
				var now = new Date().getTime()
				for (var i = 0; i < 90; i++) {
					dataList.unshift([now - this.refreshInterval * i, undefined])
				}
				var valueList = dataList.map(item => {
					return item[1]
				})
				var sumData = {}
				nv.forEach((item, index) => {
					var devicename = this.nowVariableList[index].fromName
					var typeName = this.from2name[item] ? this.from2name[item] : item
					var name = devicename /*+ "_" + typeName*/
					list.push({
						name,
						type: 'line',
						smooth: true,
						symbol: 'emptyCircle',
						sampling: 'average',
						markPoint: {
							data: [{
								name: '最大值',
								type: 'max'
							}]
						},
						data: dataList.copy()
					})
				})
				this.nowSeries = list
				this.options.series = list
				var selected = {}
				this.options.legend.data =
					nv.map((item, index) => {
						var devicename = this.nowVariableList[index].fromName
						var typeName = this.from2name[item] ? this.from2name[item] : item
						var name = devicename + "_" + typeName
						if (index > 5) {
							selected[name] = false
						}
						return {
							name: name,
							icon: 'roundRect'
						}
					})
				this.options.legend.selected = selected
				this.$refs.vchart.setData(this.options, true)
			},
			nowUnit(nv, ov) {
				this.loadDemandTree()
			}
		},
		methods: {
			treeCheckItem(item){
				this.nowDeviceList=[]
				item.forEach(list=>{
					if(list.type=='virtualDevice'){
						this.nowDeviceList.push(list)
					}
				})
			},
			loadDemandTree() {
				//查询需量设备树
			/*	this.$api.deviceApi.getReadDeviceTree(this.nowUnit.unitId, "264,265,266", respon => {
					var tree = findTreeItem([respon], item => {
					return item.unitid == this.nowUnit.id
				})
					this.demandTree = [deviceList(tree)]
					
				
				})*/
			},
			addData() {
				//增加新值
				if (isempty(this.nowVariableNameList)) {
					return
				}
				if (this.$refs.vchart == undefined) {
					return
				}
				var vl = this.realTimeValueStore.getters.getValue(this.nowVariableNameList)
				var now = Date.now()
				this.nowSeries.forEach((item, index) => {
					item.data.shift()
					var res = vl[index]
					if (isNaN(parseFloat((res))) || isnull(parseFloat((res)))) {
						res = undefined
					}
					item.data.push([now, res])
				})
				this.$refs.vchart.setData({
					series: this.nowSeries
				})
			}
		}
	}
</script>

<style scoped>
	.pageBody {
		width: 100%;
		height: 100%;
		overflow: hidden;
	}

	.infolist {
		width: auto;
		padding: 0 0.1rem;
	}

	.monreportRigth {
		display: flex;
		flex-direction: column;
		justify-content: space-around;
		width: 100%;
		height: 100%;
		overflow: hidden;
	}
	.demandRTCurveBody{
			width: 100%;
		display: flex !important;
		align-items: center;
		justify-content: space-between;
		background-color: white;
	}
</style>
